module.exports = __webpack_public_path__ + "img/big-n-line.2ef1eab.svg";